import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { pushyDeviceTokenAtom, pushyInitializedAtom } from '../atoms/v3/pushyAtoms';
import { pushyManager } from '../services/pushyManager';

/**
 * Hook to sync pushyManager state with Jotai atoms
 * This bridges the gap between the global pushyManager and React state
 */
export const usePushyManager = () => {
  const setDeviceToken = useSetAtom(pushyDeviceTokenAtom);
  const setInitialized = useSetAtom(pushyInitializedAtom);

  useEffect(() => {
    // Initial sync
    setDeviceToken(pushyManager.getDeviceToken());
    setInitialized(pushyManager.isInitialized());

    // Listen for changes
    const unsubscribe = pushyManager.addListener(() => {
      setDeviceToken(pushyManager.getDeviceToken());
      setInitialized(pushyManager.isInitialized());
    });

    return unsubscribe;
  }, [setDeviceToken, setInitialized]);
};
